import { Box, Stack, Typography } from '@mui/material';
import { useReaderContext } from '../../features/ContentRendering/components/ReaderContext';
import { useUserRelatedDocumentContext } from '../DocumentUserRelatedContext';
import ChapterButton from './Button';
import BookProgress from './BookProgress';

export default function Simplified() {
  const { currentChapter, nextChapter, previousChapter } = useReaderContext();
  const { progressData } = useUserRelatedDocumentContext();

  return (
    <Box>
      <Stack
        direction='row'
        justifyContent='space-between'
        alignItems='center'
        gap={8}
        sx={{ width: '100%' }}
      >
        {previousChapter && (
          <ChapterButton
            chapter={previousChapter}
            direction='previous'
            variant='icon'
          />
        )}

        <Typography
          component='span'
          variant='h6'
          align='center'
          sx={{ wordBreak: 'break-word', flex: 1 }}
        >
          {currentChapter?.title}
        </Typography>

        {nextChapter && (
          <ChapterButton
            chapter={nextChapter}
            direction='next'
            variant='icon'
          />
        )}
      </Stack>
      <Stack
        sx={{
          color: 'action.active',
          width: '100%',
          paddingBottom: 2,
          paddingX: 1.75,
        }}
      >
        <BookProgress value={progressData.progressPercentage} />
      </Stack>
    </Box>
  );
}
